import React, { useContext, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  enableBackupPlanStart,
  disableBackupPlanStart,
  deleteBackupPlanStart,
  toggleBackupPlansCheckList
} from "store/actions";
import { decodeHandler, displayBackupSchedule } from "utils";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";

import { LayoutContext } from "App/common/hoc/Layout";

import { setCleanBackupPlanCache } from "store/actions";

function Item(props) {
  const { lMethods, lState } = useContext(LayoutContext);
  const lStateRef = useRef();

  /*****************************Handling  popup using enter key ***************************/
  useEffect(() => {
    lStateRef.current = lState;
    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        lStateRef.current.popup.show &&
        lStateRef.current.popup.params.popupType === "item"
      ) {
        if (lStateRef.current.popup.alertName === "disableBackupPlan") {
          lStateRef.current.popup.params.execute();
        } else if (lStateRef.current.popup.alertName === "enableBackupPlan") {
          lStateRef.current.popup.params.execute();
        } else if (
          lStateRef.current.popup.alertName === "deleteBackupPlan" &&
          !lStateRef.current.popup.params.disable
        ) {
          lStateRef.current.popup.params.execute();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [lState]);

  return (
    <li
      className={`table_data_row list_folder ${
        props.data.status === props.enums.BackupPlanStatus.DISABLED
          ? props.enums.BackupPlanStatus.props[props.data.status].name
          : props.checkList.includes(props.data.planId)
          ? "active"
          : ""
      }`}
      onClick={() => {
        if (props.data.status === props.enums.BackupPlanStatus.ACTIVE) {
          lMethods.openSlidingPopup("backupPlan", "backupPlanSettings", {
            planID: props.data.planId
          });
          props.setCleanBackupPlanCache(props.data.planId);
        }
      }}
      id={`backup_plan_${props.data.planId}`}
      key={props.data.planId}
    >
      <div className="inner_data_row">
        <div className="col">
          <div className="check_wrap">
            <div className="check big" onClick={e => e.stopPropagation()}>
              <input
                type="checkbox"
                className="input_checkbox"
                id={`bkplanCheck_${props.data.planId}`}
                onChange={() =>
                  props.toggleBackupPlansCheckList(props.data.planId)
                }
                checked={props.checkList.includes(props.data.planId)}
              />
              <label htmlFor={`bkplanCheck_${props.data.planId}`} />
            </div>
          </div>
        </div>
        <div className="col col1">
          <span title={decodeHandler(props.data.planName)}>
            {decodeHandler(props.data.planName)}
          </span>
        </div>
        <div className="col col2">
          <span>
            {props.enums.BackupSource.props[props.data.backupSource]
              ? props.enums.BackupSource.props[props.data.backupSource].key
              : props.data.backupSource}
          </span>
        </div>
        <div className="col col3">
          <span>{props.data.devicesLength}</span>
        </div>
        <div className="col col4">
          <span
            title={displayBackupSchedule(props.data.scheduleInfo, props.enums)}
          >
            {displayBackupSchedule(props.data.scheduleInfo, props.enums)}
          </span>
        </div>
        {/* <div className="col col5">
        <span>Cloud Storage</span>
      </div> */}
      </div>
      <div className="table_row_options">
        <ul>
          {props.data.status === props.enums.BackupPlanStatus.ACTIVE && (
            <>
              <Tooltip {...TOOLTIPS.backupPlan.status.propagate}>
                <li
                  className="propagate"
                  onClick={e => {
                    e.stopPropagation();
                    lMethods.openSlidingPopup(
                      "backupPlan",
                      "backupPlanPropagate",
                      {
                        planID: props.data.planId
                      }
                    );
                    props.setCleanBackupPlanCache(props.data.planId);
                  }}
                >
                  <figure className="icon" />
                </li>
              </Tooltip>
              <Tooltip {...TOOLTIPS.backupPlan.status.edit}>
                <li
                  className="editPlan"
                  onClick={e => {
                    e.stopPropagation();
                    lMethods.openSlidingPopup(
                      "backupPlan",
                      "backupPlanSettings",
                      {
                        planID: props.data.planId
                      }
                    );
                    props.setCleanBackupPlanCache(props.data.planId);
                  }}
                >
                  <figure className="icon" />
                </li>
              </Tooltip>
            </>
          )}
          {props.data.status === props.enums.BackupPlanStatus.DISABLED && (
            <Tooltip {...TOOLTIPS.backupPlan.status.enable}>
              <li
                className="enable"
                onClick={e => {
                  e.stopPropagation();
                  lMethods.openPopup("enableBackupPlan", {
                    execute: () => {
                      props.enableBackupPlanStart({
                        planIDs: [props.data.planId],
                        devices: props.data.devices,
                        log: JSON.stringify({
                          mode: "backupPlan",
                          params: {
                            planName: props.data.planName,
                            action: "enabled"
                          }
                        })
                      });
                      lMethods.closePopup();
                    },
                    popupType: "item"
                  });
                }}
              >
                <figure className="icon" />
              </li>
            </Tooltip>
          )}
          {props.data.status === props.enums.BackupPlanStatus.ACTIVE && (
            <Tooltip {...TOOLTIPS.backupPlan.status.disable}>
              <li
                className="disable"
                onClick={e => {
                  e.stopPropagation();
                  lMethods.openPopup("disableBackupPlan", {
                    execute: () => {
                      props.disableBackupPlanStart({
                        planIDs: [props.data.planId],
                        devices: props.data.devices,
                        log: JSON.stringify({
                          mode: "backupPlan",
                          params: {
                            planName: props.data.planName,
                            action: "disabled"
                          }
                        })
                      });
                      lMethods.closePopup();
                    },
                    popupType: "item"
                  });
                }}
              >
                <figure className="icon" />
              </li>
            </Tooltip>
          )}
          {props.data.planId !== 1 && (
            <Tooltip {...TOOLTIPS.backupPlan.status.delete}>
              <li
                className="delete"
                onClick={e => {
                  e.stopPropagation();
                  lMethods.openPopup("deleteBackupPlan", {
                    execute: () => {
                      props.deleteBackupPlanStart({
                        planIDs: [props.data.planId],
                        devices: props.data.devices,
                        log: JSON.stringify({
                          mode: "backupPlan",
                          params: {
                            planName: props.data.planName,
                            action: "deleted"
                          }
                        })
                      });
                      lMethods.closePopup();
                    },
                    disable: true,
                    popupType: "item"
                  });
                }}
              >
                <figure className="icon" />
              </li>
            </Tooltip>
          )}
        </ul>
      </div>
    </li>
  );
}

function mapStateToProps(state) {
  return {
    enums: state.common.enums,
    checkList: state.backupPlan.backupPlans.checkList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setCleanBackupPlanCache,
      enableBackupPlanStart,
      disableBackupPlanStart,
      deleteBackupPlanStart,
      toggleBackupPlansCheckList
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Item);
